import { FC, Fragment } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
// MUI
import { Box, FormHelperText, Typography } from '@mui/material';
import { MuiOtpInput } from 'mui-one-time-password-input';
// i18next
import { useTranslation } from 'react-i18next';

type Props = {
  mfaCode: string;
  setMfaCode: (code: string) => void;
}

const VerificationStep:FC<Props> = ({ mfaCode, setMfaCode }) => {
  const { t } = useTranslation();

  const { control, formState: { errors }, watch } = useFormContext();

  const watchEmail = watch('email');

  return (
    <Fragment>
      <Typography sx={{
        mt: 4,
        textAlign: 'center',
        fontSize: { xs: 16, md: 18 }
      }}>{`We’ve sent a 6-digit verification code to ${watchEmail}. Please enter it below to continue.`}</Typography>
      <Controller
        control={control} name="mfaCode"
        rules={{ validate: (value:string) => value.length === 6 }}
        render={({ field: { onChange } }) => {
          return (
            <Box>
              <MuiOtpInput
                value={mfaCode}
                onChange={(val) => {
                  setMfaCode(val);
                  onChange(val);
                }}
                sx={(theme) => ({
                  mb: 2,
                  gap: 2,
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: errors.mfaCode ? theme.palette.error.main : theme.palette.grey[400]
                  }
                })}
                length={6}
                margin="normal"
              />
              {errors.mfaCode ? (
                <FormHelperText error>{t('validations.codeNotValid')}</FormHelperText>
              ) : null}
            </Box>
          )
        }}
      />
    </Fragment>
  )
}

export default VerificationStep;
